(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6469,1674],{

/***/ 77445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/wishlist",
      function () {
        return __webpack_require__(622007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 622007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(331399);
/* harmony import */ var _containers_Wishlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(322101);
/* harmony import */ var src_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(755847);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(268037);




// import { getRequiredCtxProps } from "src/utils/getRequiredCtxProps";
// import { getSSRStoreData } from "src/utils/ssrPageData";

var WishlistPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var storeInfo = (0,src_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,src_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        store: storeInfo,
        title: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.address) === null || ref1 === void 0 ? void 0 : ref1.visibility) === 1 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.address) === null || ref2 === void 0 ? void 0 : ref2.city) ? ", ".concat((ref3 = storeInfo.address) === null || ref3 === void 0 ? void 0 : ref3.city) : "", " - Order Online"),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.logo_image,
        metaDescription: storeInfo && (0,src_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_4__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Wishlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            props: props
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (WishlistPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,5843,6379,6246,1033,1399,3978,2682,9996,3316,9774,2888,179], function() { return __webpack_exec__(77445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);